import script from "./Blog.vue?vue&type=script&setup=true&lang=js"
export * from "./Blog.vue?vue&type=script&setup=true&lang=js"

import "./Blog.vue?vue&type=style&index=0&id=2675a670&lang=css"

const __exports__ = script;

export default __exports__